<template>
  <div v-if="false" class="mx-10 mb-2">
    <div class="p-4 rounded-xl font-bold text-sm" style="background-color:#FF9393;">
        <div v-html="lang['components']['Plan']['Index']['stop_trade_info']"></div>
    </div>
  </div>
  <div class="rounded-xl overflow-hidden" style="position:relative">
    <loading :active="!this.showPlans"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <div class="d2-plan-grid-layout">
      <!-- 左欄：目前方案 -->
      <div class="d2-plan-current" :style="guideStep == 1 ? { zIndex: 100, position: 'relative' } : null">
        <div class="d2-plan-current-label">{{lang['components']['Plan']['Index']['member_useing_plan_text']}}</div>
        <div class="d2-plan-current-name">{{ planData.plan_title }}</div>
        <div
          class="d2-plan-price-box"
          :class="{ 'plan-free': planData.plan_free, 'plan-a': planData.plan_a, 'plan-b': planData.plan_b, 'plan-c': planData.plan_c, 'plan-d': planData.plan_d, 'plan-e': planData.plan_e, 'plan-f': planData.plan_f, 'plan-o': planData.plan_o }"
        >
          <div class="price">{{ planData.plan_amount }}</div>
          <div v-if="planData.is_amount" class="unit">/{{ timeUnitText }}</div>
        </div>
        <ul class="d2-plan-features">
          <li v-for="(item, index) in planData.plan_description">
              <i class="fas fa-check"></i>
              <span v-html="item"></span>
          </li>
        </ul>
        <div class="d2-plan-status-section">
          <div class="d2-plan-status-row">
            <span class="label">
              {{lang['components']['Plan']['Index']['account_use_status']}}
              <i v-if="!connectionCardData && source == 10" class="pi pi-wallet ml-1 text-red-600 cursor-pointer" style="font-size: 1rem;" v-tooltip.top="lang['components']['Plan']['Index']['new_discount']" @click="classDiscount"></i>
            </span>
            <span class="value">{{lang['components']['Plan']['Index']['use_status'][userStatus]}}</span>
          </div>
          <div class="d2-plan-status-row">
            <span class="label">
              {{lang['components']['Plan']['Index']['member_expire_time']}}
            </span>
            <span class="value" :class="{ 'warn': isExpiredData }">{{ planData.expire_time }}</span>
          </div>
        </div>
        <div v-if="isExpiredData" class="d2-plan-warning">
          <i class="fas fa-exclamation-triangle"></i>
          <span v-if="isExpiredData && ((usePlanIdData == 1 && connectionCardData) || (usePlanIdData == 1 && !connectionCardData) || (usePlanIdData > 1 && !connectionCardData))">
            {{lang['components']['Plan']['Index']['is_not_expired']}}
          </span>
          <span v-if="connectionCardData && usePlanIdData > 1">
            {{lang['components']['Plan']['Index']['payment_error_info_text']}}
          </span>
        </div>
        <div v-if="bombmyDiscount" class="d2-plan-warning">
          <i class="fas fa-exclamation-triangle"></i>
          <span>{{lang['components']['Plan']['Index']['bombmy_discount_info']}}</span>
        </div>
        <div class="d2-plan-btn-col">
          <button class="d2-btn d2-btn-outline d2-btn-sm d2-btn-block" @click="showRecordModal=true">
            <i class="fas fa-receipt"></i> {{lang['components']['Plan']['Index']['payment_record_button_text']}}
          </button>
        </div>
      </div>
      <!-- 右欄：其他方案 -->
      <div>
        <div class="d2-plan-others-header">
          <span class="title">{{lang['components']['Plan']['Index']['other_plan_list_text']}}</span>
          <span class="hint"><i class="fas fa-info-circle"></i> {{lang['components']['Plan']['Index']['pay_unit_text']}}：{{planData.label_unit}}</span>
        </div>
        <div class="d2-plan-cards-grid">
            <PlanA v-if="usePlanIdData != 3 && plansListA.plan_a_show !== false" v-bind:lang="lang" v-bind:plansListA="plansListA" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
            <PlanB v-if="usePlanIdData == 3 || plansListA.plan_a_show === false" v-bind:lang="lang" v-bind:plansListB="plansListB" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
            <PlanD v-bind:lang="lang" v-bind:plansListD="plansListD" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
            <PlanE v-bind:lang="lang" v-bind:plansListE="plansListE" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
            <PlanF v-bind:lang="lang" v-bind:plansListF="plansListF" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
            <PlanC v-if="false" v-bind:lang="lang" v-bind:plansListC="plansListC" v-bind:isExpired="isExpiredData" v-bind:useFbCustomize="useFbCustomize" :handleChickPlan="handleChickPlan" :expCustomize="expCustomize" />
            <PlanO v-if="false" v-bind:lang="lang" v-bind:plansListO="plansListO" v-bind:isExpired="isExpiredData" :handleChickPlan="handleChickPlan" />
        </div>
      </div>
    </div>
    <ChangePlanDialog v-bind:lang="lang" v-bind:planCheck="plansCheck" v-bind:bannerColor="'fb'" v-bind:borderStyle="borderStyle" v-bind:memberId="memberId" v-model:show="showPlanModal" />
    <PayRecordDialog v-bind:lang="lang" v-bind:plansList="payListData" v-bind:userStatus="userStatus" v-model:show="showRecordModal" />
    <div v-if="guideStep == 1" style="width: 100%; height: 100vh; position: absolute; top: 0; background-color: rgba(0,0,0,0);"></div>
    <!-- ECPay 付款彈窗 -->
    <Dialog v-model:visible="showEcpayModal" class="w-4/5 lg:w-3/5 bg-white shadow rounded-xl" :modal="true" :closable="true">
      <template #header>
        <div class="w-full text-gray-900 font-semibold">信用卡付款</div>
      </template>
      <div class="py-4">
        <div id="ECPayPaymentClass" style="min-height: 400px;"></div>
      </div>
      <template #footer>
        <div class="w-full flex justify-end gap-2 py-2">
          <button
            class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-2 text-gray-500 transition duration-300 border border-gray-300"
            @click="showEcpayModal = false"
          >
            取消
          </button>
          <button
            class="bg-blue-500 hover:bg-blue-600 focus:outline-none rounded-xl px-4 py-2 text-white transition duration-300"
            :disabled="isSubmittingPayment"
            @click="submitEcpayPaymentForClass"
          >
            <span v-if="isSubmittingPayment">處理中...</span>
            <span v-else>確認付款</span>
          </button>
        </div>
      </template>
    </Dialog>

    <!-- 發票資訊彈窗 -->
    <InvoiceDialog
      v-bind:lang="lang"
      v-bind:invoiceData="invoiceData"
      v-model:show="showInvoiceModal"
      @invoiceSaved="onInvoiceSaved"
    />
  </div>
</template>

<script>
import Mask from '@/components/Event/Mask.vue';
import PlanA from './PlanA'
import PlanB from './PlanB'
import PlanC from './PlanC'
import PlanD from './PlanD'
import PlanE from './PlanE'
import PlanF from './PlanF'
import PlanO from './PlanO'
import ChangePlanDialog from '@/components/Dialog/ChangePlanDialog.vue'
import PayRecordDialog from '@/components/Dialog/PayRecordDialog.vue'
import InvoiceDialog from '@/components/Dialog/InvoiceDialog.vue'
import Dialog from 'primevue/dialog'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'

export default {
  name: 'Plan',
  props:{
    guideStep: {
      type: Number,
      default: -1
    },
    plan:{           //这个就是父组件中子标签自定义名字
      type:Object,
      // type:String,
      required:true
    },
    payList:{           //这个就是父组件中子标签自定义名字
      type:Object,
      // type:String,
      // required:true,
    },
    userStatus: {
      type: String,
      default: null
    },
    isExpired: {
      type: Boolean
    },
    lang: {
      type: Object
    },
    connectionCard: {
      type: Boolean
    },
    usePlanId: {
      type: Number
    },
    memberId: {
      type: Number
    },
    showPlans: {
      type: Boolean
    },
    transmitFbNum: {
      type: String
    },
    transmitTiktokNum: {
      type: String
    },
    source:{
      type: Number
    },
    borderStyle: {
      type: Number
    },
    useFbCustomize: {
      type: Boolean
    },
    // test:{           //这个就是父组件中子标签自定义名字
    //   type:Object,
    //   // type:String,
    //   required:true,
    //   default() {
    //     return { message: 'hello' }
    //   }
    // }
  },
  // props: ['btnName'],
  components: {
    PlanA,
    PlanB,
    PlanC,
    PlanD,
    PlanE,
    PlanF,
    PlanO,
    ChangePlanDialog,
    PayRecordDialog,
    InvoiceDialog,
    Dialog,
    Loading
  },
  data() {
    return {
      test: ["試用15天","1個 行銷活動可使用"],
      showPlanModal: false,
      showRecordModal: false,
      selectPlan: null,
      changeCreditCard: false,
      bombmyDiscount: false,
      formActive: null,
      CardID: null,
      ClientRedirectURL: null,
      MerchantID: null,
      MerchantMemberID: null,
      MerchantTradeDate: null,
      MerchantTradeNo: null,
      ServerReplyURL: null,
      stage: null,
      TotalAmount: null,
      TradeDesc: null,
      CheckMacValue: null,
      plansListA:{
                    plan_a_title:null,
                    plan_a_amount:null,
                    plan_a_description:null,
                    plan_a_disable:null,
                    plan_a_text:null,
                    plan_a_show:null,
                    planHaveBind:false,
                  },
      plansListB:{
                    plan_b_title:null,
                    plan_b_amount:null,
                    plan_b_description:null,
                    plan_b_disable:null,
                    plan_b_text:null,
                    plan_b_show:null,
                    planHaveBind:false,
                  },
      plansListC:{
                    plan_c_title:null,
                    plan_c_amount:null,
                    plan_c_description:null,
                    plan_c_disable:null,
                    plan_c_text:null,
                    plan_c_show:null,
                    planHaveBind:false,
                  },
      plansListD:{
                    plan_d_title:null,
                    plan_d_amount:null,
                    plan_d_description:null,
                    plan_d_disable:null,
                    plan_d_text:null,
                    plan_d_show:null,
                    planHaveBind:false,
                  },
      plansListE:{
                    plan_e_title:null,
                    plan_e_amount:null,
                    plan_e_description:null,
                    plan_e_disable:null,
                    plan_e_text:null,
                    plan_e_show:null,
                    planHaveBind:false,
                  },
      plansListF:{
                    plan_f_title:null,
                    plan_f_amount:null,
                    plan_f_description:null,
                    plan_f_disable:null,
                    plan_f_text:null,
                    plan_f_show:null,
                    planHaveBind:false,
                  },
      plansListO:{
                    plan_id:null,
                    plan_o_title:null,
                    plan_o_amount:null,
                    plan_o_description:null,
                    plan_o_disable:null,
                    plan_o_text:null,
                    plan_o_show:null,
                    planHaveBind:false,
                    is_amount:true,
                  },
      payError: true,
      isPay: false,
      plansCheck:{
                    title : null,
                    currency : null,
                    PeriodAmount : null,
                    description : null,
                    expire_time : null,
                    card_no : null,
                    haveBind : null,
                  },
      currency: null,
      PeriodAmount: null,
      title: null,
      planId: null,
      showEcpayModal: false,
      showInvoiceModal: false,
      invoiceData: {
        identifier: '',
        name: '',
        address: '',
        mobile: '',
        email: ''
      },
      pendingClassPayment: null,
      payMethod: 'credit',
      ecpaySdkLoaded: false,
      isSubmittingPayment: false
    }
  },
  created() {
    axios
      .post('https://www.autoturn.net/api/plan.php', Qs.stringify({
        s_code: this.$route.params.id,
        type: 'fb'
      }))
      .then((response) => {
        if(response.data.status == 'success'){
          let aDescription = [];
          let tmpADescription = JSON.parse(response.data.plan_a_description);
          for(let i = 0; i < tmpADescription.length; i++){
            aDescription.push(tmpADescription[i]);
          }

          this.plansListA = {
                                plan_a_title : response.data.plan_a_title,
                                plan_a_amount : response.data.plan_a_amount,
                                plan_a_label_amount : response.data.plan_a_label_amount,
                                plan_a_description : aDescription,
                                plan_a_disable : response.data.plan_a_disable,
                                plan_a_text : response.data.plan_a_text,
                                plan_a_show : response.data.plan_a_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let bDescription = [];
          let tmpBDescription = JSON.parse(response.data.plan_b_description);
          for(let i = 0; i < tmpBDescription.length; i++){
            bDescription.push(tmpBDescription[i]);
          }

          this.plansListB = {
                                plan_b_title : response.data.plan_b_title,
                                plan_b_amount : response.data.plan_b_amount,
                                plan_b_label_amount : response.data.plan_b_label_amount,
                                plan_b_description : bDescription,
                                plan_b_disable : response.data.plan_b_disable,
                                plan_b_text : response.data.plan_b_text,
                                plan_b_show : response.data.plan_b_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let cDescription = [];
          let tmpCDescription = JSON.parse(response.data.plan_c_description);
          for(let i = 0; i < tmpCDescription.length; i++){
            cDescription.push(tmpCDescription[i]);
          }

          this.plansListC = {
                                plan_c_title : response.data.plan_c_title,
                                plan_c_amount : response.data.plan_c_amount,
                                plan_c_label_amount : response.data.plan_c_label_amount,
                                plan_c_description : cDescription,
                                plan_c_disable : response.data.plan_c_disable,
                                plan_c_text : response.data.plan_c_text,
                                plan_c_show : response.data.plan_c_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let dDescription = [];
          let tmpDDescription = JSON.parse(response.data.plan_d_description);
          for(let i = 0; i < tmpDDescription.length; i++){
            dDescription.push(tmpDDescription[i]);
          }

          this.plansListD = {
                                plan_d_title : response.data.plan_d_title,
                                plan_d_amount : response.data.plan_d_amount,
                                plan_d_label_amount : response.data.plan_d_label_amount,
                                plan_d_description : dDescription,
                                plan_d_disable : response.data.plan_d_disable,
                                plan_d_text : response.data.plan_d_text,
                                plan_d_show : response.data.plan_d_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let eDescription = [];
          let tmpEDescription = JSON.parse(response.data.plan_e_description);
          for(let i = 0; i < tmpEDescription.length; i++){
            eDescription.push(tmpEDescription[i]);
          }

          this.plansListE = {
                                plan_e_title : response.data.plan_e_title,
                                plan_e_amount : response.data.plan_e_amount,
                                plan_e_label_amount : response.data.plan_e_label_amount,
                                plan_e_description : eDescription,
                                plan_e_disable : response.data.plan_e_disable,
                                plan_e_text : response.data.plan_e_text,
                                plan_e_show : response.data.plan_e_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let fDescription = [];
          let tmpFDescription = JSON.parse(response.data.plan_f_description);
          for(let i = 0; i < tmpFDescription.length; i++){
            fDescription.push(tmpFDescription[i]);
          }

          this.plansListF = {
                                plan_f_title : response.data.plan_f_title,
                                plan_f_amount : response.data.plan_f_amount,
                                plan_f_label_amount : response.data.plan_f_label_amount,
                                plan_f_description : fDescription,
                                plan_f_disable : response.data.plan_f_disable,
                                plan_f_text : response.data.plan_f_text,
                                plan_f_show : response.data.plan_f_show,
                                planHaveBind: response.data.planHaveBind,
                              }

          let oDescription = [];
          let tmpODescription = JSON.parse(response.data.plan_o_description);
          for(let i = 0; i < tmpODescription.length; i++){
            oDescription.push(tmpODescription[i]);
          }

          this.plansListO = {
                                plan_id: response.data.plan_id,
                                plan_o_title : response.data.plan_o_title,
                                plan_o_amount : response.data.plan_o_amount,
                                plan_o_label_amount : response.data.plan_o_label_amount,
                                plan_o_description : oDescription,
                                plan_o_disable : response.data.plan_o_disable,
                                plan_o_text : response.data.plan_o_text,
                                plan_o_show : response.data.plan_o_show,
                                planHaveBind: response.data.planHaveBind,
                                is_amount: response.data.is_amount,
                              }

          if(response.data.plan_id > 1){
            this.isPay = true
          }

          this.bombmyDiscount = response.data.bombmy_discount;
          this.payMethod = response.data.pay_method || 'credit';
        } else {
          // console.log('created plan index logout');
          // window.location.href = "https://www.autoturn.net/index.php/login/view";
        }
      });
  },
  methods: {
    handleChickPlan(plan, view, active, type) {
      //console.log('plan:'+plan);
      //console.log('view:'+view);
      this.showPlanModal = true
      this.selectPlan = plan

      let payAgain = false;
      if(active == 'payAgain'){
        payAgain = true;
      }

      axios
      .post('https://www.autoturn.net/api/plan_check.php', Qs.stringify({
        s_code: this.$route.params.id,
        plan_id: this.selectPlan,
        data_type: view,
        type: type
      }))
      .then((response) => {
        if(response.data.status == 'success'){
          let description = [];
          let tmpDescription = JSON.parse(response.data.description);
          for(let i = 0; i < tmpDescription.length; i++){
            description.push(tmpDescription[i]);
          }

          this.plansCheck = {
                              title : response.data.title,
                              currency : response.data.currency,
                              label_currency : response.data.label_currency,
                              PeriodAmount : response.data.PeriodAmount,
                              label_PeriodAmount : response.data.label_PeriodAmount,
                              description : description,
                              expire_time : response.data.expire_time,
                              card_no : response.data.card_no,
                              haveBind : response.data.haveBind,
                              memberId : response.data.memberId,
                              planId : plan,
                              payStatus: response.data.payStatus,
                              payMethod: response.data.payMethod || this.payMethod || 'credit',
                              payAgain: payAgain,
                              plan_type: view,
                              check_plan_id: plan,
                              use_plan_id: this.usePlanIdData,
                              is_expired: this.isExpiredData,
                              plan_type: view,
                              Frequency : response.data.Frequency
                            }
        } else {
          // console.log('handleChickPlan plan index logout');
          // window.location.href = "https://www.autoturn.net/index.php/login/view";
        }
      });
    },
    expCustomize(){
      //console.log('expCustomize');

      Swal.fire({
        title: 'Autoturn Plus方案 - 流程體驗',
        html: '申請完成後，您將享有 <span style="color: #FF0000;">14 天</span>自由體驗自定義設定的時間，但<span style="color: #FF0000;">在體驗期間，無法發布自定義活動，且每位用戶只能申請一次體驗</span>，請問您要申請體驗自定義功能嗎？',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: '我要申請',
        cancelButtonText: '我再想想',
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .post('https://www.autoturn.net/api/customize/data/experience_customize_create.php', Qs.stringify({
              s_code: this.$route.params.id,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                Swal.fire(
                  'Autoturn Plus方案 - 流程體驗',
                  response.data.info,
                  response.data.status
                );

                var todayForm = new Date();
                var yearForm = todayForm.getFullYear();
                var dateForm = String(todayForm.getDate()).padStart(2, '0');
                var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                let get_value = 'true_'+yearForm + monthForm + dateForm + timeForm;

                this.$emit('canUseFbCustomize', get_value);
              } else {
                Swal.fire(
                  'Autoturn Plus方案 - 流程體驗',
                  response.data.info,
                  response.data.status
                );
              }
            });
        }
      });
    },
    planPayAgain(plan) {
      // console.log('plan:'+plan);
      this.showPlanModal = true
      this.selectPlan = plan

      axios
      .post('https://www.autoturn.net/api/plan_check.php', Qs.stringify({
        s_code: this.$route.params.id,
        plan_id: this.selectPlan
      }))
      .then((response) => {
        if(response.data.status == 'success'){
          let description = [];
          let tmpDescription = JSON.parse(response.data.description);
          for(let i = 0; i < tmpDescription.length; i++){
            description.push(tmpDescription[i]);
          }

          this.plansCheck = {
                              title : response.data.title,
                              currency : response.data.currency,
                              PeriodAmount : response.data.PeriodAmount,
                              description : description,
                              expire_time : response.data.expire_time,
                              card_no : response.data.card_no,
                              haveBind : response.data.haveBind,
                              memberId : response.data.memberId,
                              planId : plan,
                              payStatus: response.data.payStatus,
                              payMethod: response.data.payMethod || this.payMethod || 'credit',
                              Frequency : response.data.Frequency
                            }
        } else {
          // console.log('handleChickPlan plan index logout');
          // window.location.href = "https://www.autoturn.net/index.php/login/view";
        }
      });
    },
    async classDiscount(){
      //console.log('classDiscount');
      //console.log(this.memberId);

      try {
        const response = await axios.post('https://www.autoturn.net/api/class_discount_check.php', Qs.stringify({
          s_code: this.$route.params.id,
          source: this.source,
        }))

          if(response.data.status == 'success'){
            this.currency = response.data.currency;
            this.PeriodAmount = response.data.period_amount;
            this.title = response.data.title;
            this.planId = response.data.plan_id;

          const result = await Swal.fire({
              title: this.lang['components']['Plan']['Index']['methods']['classDiscount']['swal_title'],
              html: this.lang['components']['Plan']['Index']['methods']['classDiscount']['swal_text'],
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: this.lang['components']['Plan']['Index']['methods']['classDiscount']['confirm_button_text'],
              cancelButtonText: this.lang['components']['Plan']['Index']['methods']['classDiscount']['cancel_button_text'],
          })

              if (result.isConfirmed) {
            // 檢查發票資訊
            const hasInvoice = await this.checkInvoiceDataForClass()

            if (!hasInvoice) {
              // 沒有發票資訊，顯示發票填寫彈窗
              this.pendingClassPayment = {
                memberId: this.memberId,
                currency: this.currency,
                price: this.PeriodAmount,
                planTitle: this.title,
                planId: this.planId
              }
              this.showInvoiceModal = true
              return
            }

            // 有發票資訊，直接付款
            await this.proceedClassPayment()
          }
          } else {
            Swal.fire(
              this.lang['components']['Plan']['Index']['methods']['classDiscount']['swal_title'],
              response.data.info,
              response.data.status
            );
          }
      } catch (error) {
        console.error('classDiscount error:', error)
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: '發生錯誤，請稍後再試'
        })
      }
    },

    // 檢查發票資訊
    async checkInvoiceDataForClass() {
      try {
        const response = await axios.post('https://www.autoturn.net/api/data/invoice_check.php', Qs.stringify({
          s_code: this.$route.params.id
        }))

        if (response.data.status === 'success') {
          this.invoiceData = response.data.invoiceData
          return response.data.hasInvoiceData
        }
        return false
      } catch (error) {
        console.error('檢查發票資訊失敗:', error)
        return false
      }
    },

    // 發票資訊儲存完成後的回調
    onInvoiceSaved() {
      this.showInvoiceModal = false
      // 繼續執行付款流程
      if (this.pendingClassPayment) {
        this.proceedClassPayment()
      }
    },

    // 執行課程優惠付款
    async proceedClassPayment() {
      try {
        const response = await axios.post('https://www.autoturn.net/udnapi/account_info/create_hidden_data_v3.php', Qs.stringify({
          member_id: this.memberId,
          currency: this.currency,
          price: this.PeriodAmount,
          plan_title: this.title,
          plan_id: this.planId,
          hash: this.$route.params.id
        }))

        if (response.data.status === 'success') {
          // 載入 ECPay SDK 並顯示付款畫面
          this.loadEcpaySdkForClass(response.data.data)
        } else {
          Swal.fire({
            icon: 'error',
            title: '付款失敗',
            text: response.data.info
          })
        }
      } catch (error) {
        console.error('取得 Token 失敗:', error)
        Swal.fire({
          icon: 'error',
          title: '付款失敗',
          text: '無法連線到付款伺服器，請稍後再試'
        })
      }
    },

    // 載入 ECPay SDK (課程優惠用)
    loadEcpaySdkForClass(data) {
      this.showEcpayModal = true

      if (this.ecpaySdkLoaded) {
        this.initEcpayPaymentForClass(data.Token)
        return
      }

      if (!window.jQuery) {
        const jqueryScript = document.createElement('script')
        jqueryScript.src = 'https://code.jquery.com/jquery-3.5.1.min.js'
        jqueryScript.onload = () => {
          this.loadEcpaySdkScriptForClass(data)
        }
        document.head.appendChild(jqueryScript)
      } else {
        this.loadEcpaySdkScriptForClass(data)
      }
    },

    loadEcpaySdkScriptForClass(data) {
      const script = document.createElement('script')
      script.src = data.SdkUrl
      script.onload = () => {
        this.ecpaySdkLoaded = true
        this.initEcpayPaymentForClass(data.Token)
      }
      script.onerror = () => {
        Swal.fire({
          icon: 'error',
          title: '載入失敗',
          text: '無法載入付款元件，請重新整理頁面後再試'
        })
        this.showEcpayModal = false
      }
      document.head.appendChild(script)
    },

    initEcpayPaymentForClass(token) {
      const self = this
      this.$nextTick(() => {
        // 確保 DOM 元素存在
        const container = document.getElementById('ECPayPaymentClass')
        if (!container) {
          console.error('ECPay 容器元素不存在')
          return
        }

        if (window.ECPay) {
          // Step 1: ECPay.initialize(ServerType, IsLoading, callBack)
          // ServerType: 'Stage' 測試環境, 'Prod' 正式環境
          // IsLoading: 1 顯示等待畫面
          const serverType = 'Prod' // 測試環境

          window.ECPay.initialize(serverType, 1, function(errMsg) {
            if (errMsg) {
              console.error('ECPay 初始化錯誤:', errMsg)
              Swal.fire({
                icon: 'error',
                title: '付款元件初始化失敗',
                text: errMsg
              })
              return
            }
            console.log('ECPay SDK 初始化成功')

            // Step 2: ECPay.addBindingCard(Token, Language, callBack)
            // 取得綁定信用卡畫面
            var lang = window.ECPay.Language.zhTW // 繁體中文

            window.ECPay.addBindingCard(token, lang, function(bindErrMsg) {
              if (bindErrMsg) {
                console.error('ECPay 綁定信用卡畫面錯誤:', bindErrMsg)
                Swal.fire({
                  icon: 'error',
                  title: '載入付款畫面失敗',
                  text: bindErrMsg
                })
              } else {
                console.log('ECPay 綁定信用卡畫面載入成功')
              }
            })
          })
        } else {
          console.error('ECPay SDK 未載入')
        }
      })
    },

    // 提交 ECPay 付款 (課程優惠用)
    submitEcpayPaymentForClass() {
      if (!window.ECPay) {
        Swal.fire({
          icon: 'error',
          title: '錯誤',
          text: '付款元件尚未載入'
        })
        return
      }

      console.log('ECPay 可用方法:', Object.keys(window.ECPay))

      this.isSubmittingPayment = true
      const self = this

      if (typeof window.ECPay.getBindCardPayToken === 'function') {
        window.ECPay.getBindCardPayToken(function(paymentInfo, errMsg) {
          if (errMsg) {
            self.isSubmittingPayment = false
            console.error('ECPay 綁卡錯誤:', errMsg)
            Swal.fire({
              icon: 'error',
              title: '付款失敗',
              text: errMsg
            })
            return
          }

          if (paymentInfo) {
            console.log('ECPay 綁卡成功，paymentInfo:', paymentInfo)
            self.completeBindCardPaymentForClass(paymentInfo)
          }
        })
      } else {
        this.isSubmittingPayment = false
        console.error('ECPay.getBindCardPayToken 方法不存在')
        Swal.fire({
          icon: 'warning',
          title: 'ECPay SDK 錯誤',
          html: `<p>找不到 getBindCardPayToken 方法</p>`
        })
      }
    },

    // 完成綁卡付款 (課程優惠用)
    async completeBindCardPaymentForClass(paymentInfo) {
      try {
        Swal.fire({
          title: '處理中',
          text: '正在處理您的付款，請稍候...',
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => {
            Swal.showLoading()
          }
        })

        const response = await axios.post('https://www.autoturn.net/udnapi/account_info/create_bindcard_payment.php', Qs.stringify({
          bind_card_pay_token: paymentInfo.BindCardPayToken,
          merchant_trade_no: paymentInfo.MerchantTradeNo,
          member_id: this.memberId
        }))

        this.isSubmittingPayment = false

        if (response.data.status === 'success') {
          if (response.data.need3D && response.data.threeDURL) {
            window.location.href = response.data.threeDURL
            return
          }

          this.showEcpayModal = false
          Swal.fire({
            icon: 'success',
            title: '付款成功',
            text: '您的付款已完成！',
            confirmButtonText: '確定'
          }).then(() => {
            window.location.reload()
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: '付款失敗',
            text: response.data.info || '付款處理失敗'
          })
        }
      } catch (error) {
        this.isSubmittingPayment = false
        console.error('完成付款失敗:', error)
        Swal.fire({
          icon: 'error',
          title: '付款失敗',
          text: '無法連線到付款伺服器'
        })
      }
    }
  },
  computed: {
    planData: {
      get: function () {
        return this.plan
      },
      set: function (value) {
        this.$emit('update:planData', value)
      }
    },
    payListData: {
      get: function () {
        return this.payList
      },
      set: function (value) {
        this.$emit('update:payList', value)
      }
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      }
    },
    connectionCardData: {
      get: function () {
        return this.connectionCard
      },
      set: function (value) {
        this.$emit('update:connectionCardData', value)
      }
    },
    usePlanIdData: {
      get: function () {
        return this.usePlanId
      },
      set: function (value) {
        this.$emit('update:usePlanIdData', value)
      }
    },
    timeUnitText() {
      const frequency = this.planData.plan_frequency || 1;
      if (frequency === 3) {
        return this.lang['components']['Plan']['PlanD']['time_unit']; // 季
      } else if (frequency === 12) {
        return this.lang['components']['Plan']['Index']['time_unit_year']; // 年
      } else {
        return this.lang['components']['Plan']['Index']['time_unit']; // 月
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>